import { useQuery } from 'react-query'
import useSingleStation from '../useSingleStation';
import { getEnergyActiveImportData } from '../../services/stationsAPI';
import { useFilterAnalysis } from '../../../../common/analysis/filter/hook';

export default function useStationDataEnergyActiveImport(stationId?: string) {
    const {stationId: stationIdUrl} = useSingleStation() 
  const {filter} = useFilterAnalysis()
    const stationIdFound = stationId || stationIdUrl;

    const energyActiveImportQuery = useQuery({
    queryKey: ['stationDataEnergyActiveImport', stationId, filter],
    queryFn: () => getEnergyActiveImportData(stationIdFound || "none", filter),
    enabled: !!stationIdFound,

    })


  return {
    energyActiveImportQuery,
    filter,
  }
}
